export default __webpack_public_path__ + "static/53-db86b7ef570230b14568dc9abcda2681.gif";